import { INPUT_METHOD } from '@atlaskit/editor-common/analytics';
import { bindKeymapWithCommand, escape, insertRule } from '@atlaskit/editor-common/keymaps';
import { keymap } from '@atlaskit/editor-prosemirror/keymap';
import { insertHorizontalRule } from './commands';
export function keymapPlugin(editorAnalyticsAPI) {
  var list = {};
  bindKeymapWithCommand(
  // Ignored via go/ees005
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  insertRule.common, insertHorizontalRule(editorAnalyticsAPI)(INPUT_METHOD.SHORTCUT), list);

  // Ignored via go/ees005
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  bindKeymapWithCommand(escape.common, function () {
    return true;
  }, list);
  return keymap(list);
}
export default keymapPlugin;